<template>
    <div v-if="roster">

        <h3>{{ roster.market }} {{ roster.name }}</h3>

        <h4>players</h4>

        <table class="table">
            <tr>
                <th>id</th>
                <th>name</th>
                <th>birth_date</th>
                <th>college</th>
                <th>height</th>
                <th>jersey</th>
                <th>abbr_name</th>
                <th>first_name</th>
                <th>last_name</th>
                <th>status</th>
                <th>position</th>
                <th>status</th>
                <th>weight</th>
            </tr>
            <tr v-for="player in roster.players">
                <td>{{ player.id }}</td>
                <td>{{ player.name }}</td>
                <td>{{ player.birth_date }}</td>
                <td>{{ player.college }}</td>
                <td>{{ player.height }}</td>
                <td>{{ player.jersey }}</td>
                <td>{{ player.abbr_name }}</td>
                <td>{{ player.first_name }}</td>
                <td>{{ player.last_name }}</td>
                <td>{{ player.status }}</td>
                <td>{{ player.position }}</td>
                <td>{{ player.status }}</td>
                <td>{{ player.weight }}</td>
            </tr>
        </table>

        <h4>coaches</h4>

        <table class="table">
            <tr>
                <th>id</th>
                <th>full_name</th>
                <th>first_name</th>
                <th>last_name</th>
                <th>position</th>
            </tr>
            <tr v-for="player in roster.coaches">
                <td>{{ player.id }}</td>
                <td>{{ player.full_name }}</td>
                <td>{{ player.first_name }}</td>
                <td>{{ player.last_name }}</td>
                <td>{{ player.position }}</td>
            </tr>
        </table>
    </div>
    
</template>

<script>
export default {
    name: 'NFLRoster',
    props: {
        roster: '',
        team_role: '',
    },
    data: function() {
        return {            
            
        }
    }, 
}
</script>

